import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { useToast } from "../../../Services/ToastContext";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import { usePostData } from "../../../hooks";
import { EndPoints } from "../../../Constants/endpoints";
import { GeneralButton, GeneralInput, Modal } from "../../../components";
import Ic_complaints from "../../../assets/images/icons/complaints_and_suggestions.svg";

function ComplaintsAndSuggestions() {
  const { t } = useTranslation();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const HelpCenterSchema = z.object({
    Title: z.string().nonempty(t("required")),
    Description: z.string().nonempty(t("required")),
  });
  type AddHelpCenter = z.infer<typeof HelpCenterSchema>;
  const { showToast } = useToast();
  const methods = useForm<AddHelpCenter>({
    resolver: zodResolver(HelpCenterSchema),
    defaultValues: {
      Title: "",
      Description: "",
    },
    mode: "onBlur",
    shouldUnregister: false,
  });
  const { handleSubmit, reset } = methods;
  const { mutate, isPending } = usePostData(EndPoints.AddComplaint);

  const onSubmit = (data: AddHelpCenter) => {
    mutate(data, {
      onSuccess: () => {
        reset();
        setIsConfirmOpen(false);
        showToast(t("added_successfully"), "success");
      },
      onError: (error) => {
        showToast(error.message, "error");
      },
    });
  };
  return (
    <div>
      <GeneralButton
        color="blue"
        className="!px-5"
        icon={Ic_complaints}
        title={t("complaints_and_suggestions")}
        onClick={() => setIsConfirmOpen(true)}
      />
      <Modal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        header={t("please_enter_your_old_password")}
      >
        <FormProvider {...methods}>
          <form
            className="flex w-full flex-col justify-between gap-3"
            onSubmit={handleSubmit(onSubmit)}
          >
            <GeneralInput
              name="Title"
              label={t("complaint_title")}
              placeholder={t("complaint_title")}
            />
            <GeneralInput
              name="Description"
              label={t("type_the_complaint")}
              placeholder={t("type_the_complaint")}
              type="textarea"
            />
            <div className="mt-5 flex justify-end gap-1">
              <GeneralButton
                type="button"
                fontColor="body-text"
                title={t("cancel")}
                color="lite"
                onClick={() => methods.reset()}
              />
              <GeneralButton
                type="submit"
                title={t("send")}
                color="blue"
                className="!px-5"
                isLoading={isPending}
              />
            </div>
          </form>
        </FormProvider>
      </Modal>
    </div>
  );
}

export default ComplaintsAndSuggestions;
